<div class="pr-panel-body" [ngClass]="clazz">
  <ng-content></ng-content>
</div>
